import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';

//component:
import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../components/int_number_input_formatter';


import {
    navigate, hideDialog
} from '../../actions';

import {
    copyCentroDB, createNewCentroDB
} from '../../actions/centro_actions';

const styles = theme => ({
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
        marginTop: 15,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formSelect: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 0 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    label: {
        fontSize: 15,
        fontWeight: '400',
        display: 'flex',
        alignItems: 'center',
        marginRight: 20,
    },
    formSelectRadio: {
        display: 'flex',
        minWidth: 120,
        height: 50,
        width: 185,
    },
    buttonsBottom: {
        marginTop: 25,
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    radiobuttonLabel: {
        display: 'flex',
        marginTop: 20
    },
    rtl: {
        textAlign: 'right',
    }
});

class CentroNew extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nombre: '',
            type: 'blank',
            centro_copia: -1,
            empresa: this.props.empresas[0].id,
            grupo: false,
            fondoTokens: 0,
            fondoEuros: 0
        }
    }

    handleValueChange = (event, field) => {
        
        if(field === 'centro_copia'){
            var centro = this.props.centros.find(c => c.id === event.target.value);
            this.setState({ ...this.state, centro_copia: event.target.value, fondoTokens: centro.fondoTokens, fondoEuros: centro.fondoEuros });
        }
        else{
            this.setState({ ...this.state, [field]: event.target.value });
        }
    }

    createCopySelectOptions = () => {
        return this.props.centros.map((centro, index) => {
            return (
                <MenuItem key={centro.id} value={centro.id}>{centro.centro}</MenuItem>
            );
        })
    }

    createEmpresaSelectOptions = () => {

        return this.props.empresas.map((emp, index) => {
            return (
                <MenuItem key={emp.id} value={emp.id}>{emp.empresa1}</MenuItem>
            );
        })
    }

    handleGrupoChange = (event) => {
        let type = this.state.type;
        if(event.target.checked) type = 'blank';
        this.setState({ ...this.state, grupo: event.target.checked, type:type });
    };

    render() {

        const { classes } = this.props;

        return (
            <div>
                <form>
                    <Grid container spacing={16}>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='nombre'
                                    label='Nombre'
                                    placeholder='Nombre'
                                    value={this.state.nombre}
                                    onChange={(event) => this.handleValueChange(event, 'nombre')}
                                />
                            </FormControl>


                            <FormControl className={classes.formSelect}>
                                <InputLabel htmlFor="empresa-placeholder" style={{ paddingTop: 18 }}>Empresa: </InputLabel>
                                <Select
                                    value={this.state.empresa}
                                    onChange={(event) => this.handleValueChange(event, 'empresa')}
                                    name="empresa"
                                    disabled={this.state.type === 'copy'}
                                >
                                    {this.createEmpresaSelectOptions()}
                                </Select>
                            </FormControl>
                        </div>

                        <div className={classes.containerPair}>
                            {/* <FormControl component="fieldset" className={classes.formControl}> */}
                            <RadioGroup
                                style={{ display: 'flex', marginLeft: 16, marginBottom: 20 }}
                                aria-label="Copy Center"
                                name="copyCenter"
                                value={this.state.type}
                                onChange={(event) => this.handleValueChange(event, 'type')}
                            >
                                <FormControlLabel value="blank" className={classes.label} control={<Radio />} label="Centro en blanco" />
                                <FormControlLabel value="copy" control={<Radio />} disabled={this.state.grupo} label={
                                    <div className={classes.radiobuttonLabel}>
                                        <p className={classes.label} htmlFor="dia-cierre-placeholder">Centro similar a: </p>
                                        <FormControl className={classes.formSelectRadio}>
                                            <Select
                                                disabled={this.state.type === 'blank'}
                                                value={this.state.centro_copia}
                                                onChange={(event) => this.handleValueChange(event, 'centro_copia')}
                                                name="centro_copia"
                                            >
                                                {this.createCopySelectOptions()}
                                            </Select>
                                        </FormControl>
                                    </div>
                                }
                                />
                            </RadioGroup>
                            {/* </FormControl> */}
                        </div>
                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='fondoEuros'
                                    label='Fondo inicial €'
                                    placeholder='Fondo inicial €'
                                    value={this.state.fondoEuros}
                                    InputProps={{ classes: { input: classes.rtl }, inputComponent: FloatNumberFormatInput }}
                                    onChange={(event) => this.handleValueChange(event, 'fondoEuros')}
                                />
                            </FormControl>


                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='fondoTokens'
                                    label='Fondo inicial tokens'
                                    placeholder='Nombre'
                                    value={this.state.fondoTokens}
                                    InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                                    onChange={(event) => this.handleValueChange(event, 'fondoTokens')}
                                />
                            </FormControl>
                        </div>

                        <FormControl className={classes.formControl}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.grupo}
                                        onChange={this.handleGrupoChange}
                                        value={'grupo'}
                                        color="primary"
                                    />
                                }
                                label="Grupo"
                            />
                        </FormControl>

                    </Grid>

                    <div>
                        <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                        <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                            if (this.state.nombre) {
                                if (this.state.type === 'blank') {
                                    this.props.createNewCentroDB(this.state.nombre, this.state.empresa, this.state.grupo, this.state.fondoEuros, this.state.fondoTokens);
                                } else if (this.state.type === 'copy' && this.state.centro_copia !== -1) {
                                    this.props.copyCentroDB(this.state.centro_copia, this.state.nombre, this.state.fondoEuros, this.state.fondoTokens);
                                }
                                this.props.hideDialog();
                            }

                        }}>Guardar</Button>
                    </div>


                </form>

            </div>
        );
    };

};

CentroNew.propTypes = {
    //state
    centros: PropTypes.array.isRequired,
    empresas: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    copyCentroDB: PropTypes.func.isRequired,
    createNewCentroDB: PropTypes.func.isRequired,

    //parameters
    nombre: PropTypes.string,
    direccion1: PropTypes.string,
    direccion2: PropTypes.string,
    iDiaCierre: PropTypes.number,
    canal: PropTypes.number,
    empresa: PropTypes.number,
    id: PropTypes.number,
};


function mapStateToProps(state) {
    return {
        centros: state.centros.centros,
        empresas: state.empresas.empresas,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate: navigate,
        hideDialog: hideDialog,
        copyCentroDB: copyCentroDB,
        createNewCentroDB: createNewCentroDB
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CentroNew));